/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/Company', 'model/PartnerCompany'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/Company'), require('../model/PartnerCompany'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.CompanyApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.Company, root.ForStractionServiceApi.PartnerCompany);
  }
}(this, function(ApiClient, Company, PartnerCompany) {
  'use strict';

  /**
   * Company service.
   * @module api/CompanyApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new CompanyApi. 
   * @alias module:api/CompanyApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the companyAddClientCompanyPut operation.
     * @callback module:api/CompanyApi~companyAddClientCompanyPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * addClientCompany
     * @param {String} _4SAPIAppID 
     * @param {module:model/Company} body 
     * @param {Integer} templateID 
     * @param {String} firstUserEmail 
     * @param {Boolean} usesNetvisor 
     * @param {String} logoURI 
     * @param {module:api/CompanyApi~companyAddClientCompanyPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.companyAddClientCompanyPut = function(_4SAPIAppID, body, templateID, firstUserEmail, usesNetvisor, logoURI, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling companyAddClientCompanyPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling companyAddClientCompanyPut";
      }

      // verify the required parameter 'templateID' is set
      if (templateID == undefined || templateID == null) {
        throw "Missing the required parameter 'templateID' when calling companyAddClientCompanyPut";
      }

      // verify the required parameter 'firstUserEmail' is set
      if (firstUserEmail == undefined || firstUserEmail == null) {
        throw "Missing the required parameter 'firstUserEmail' when calling companyAddClientCompanyPut";
      }

      // verify the required parameter 'usesNetvisor' is set
      if (usesNetvisor == undefined || usesNetvisor == null) {
        throw "Missing the required parameter 'usesNetvisor' when calling companyAddClientCompanyPut";
      }

      // verify the required parameter 'logoURI' is set
      if (logoURI == undefined || logoURI == null) {
        throw "Missing the required parameter 'logoURI' when calling companyAddClientCompanyPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'templateID': templateID,
        'firstUserEmail': firstUserEmail,
        'usesNetvisor': usesNetvisor,
        'logoURI': logoURI
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/Company/addClientCompany', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the companyEditCurrentCompanyPut operation.
     * @callback module:api/CompanyApi~companyEditCurrentCompanyPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * editCurrentCompany
     * @param {String} _4SAPIAppID 
     * @param {module:model/Company} body 
     * @param {module:api/CompanyApi~companyEditCurrentCompanyPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.companyEditCurrentCompanyPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling companyEditCurrentCompanyPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling companyEditCurrentCompanyPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/Company/editCurrentCompany', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the companyLoadCurrentCompanyGet operation.
     * @callback module:api/CompanyApi~companyLoadCurrentCompanyGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Company} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadCurrentCompany
     * @param {String} _4SAPIAppID 
     * @param {module:api/CompanyApi~companyLoadCurrentCompanyGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/Company}
     */
    this.companyLoadCurrentCompanyGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling companyLoadCurrentCompanyGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Company;

      return this.apiClient.callApi(
        '/Company/loadCurrentCompany', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the companyLoadPartnerCompaniesGet operation.
     * @callback module:api/CompanyApi~companyLoadPartnerCompaniesGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/PartnerCompany>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadPartnerCompanies
     * @param {String} _4SAPIAppID 
     * @param {module:api/CompanyApi~companyLoadPartnerCompaniesGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/PartnerCompany>}
     */
    this.companyLoadPartnerCompaniesGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling companyLoadPartnerCompaniesGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [PartnerCompany];

      return this.apiClient.callApi(
        '/Company/loadPartnerCompanies', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the companySendNotificationToContractSigneeGet operation.
     * @callback module:api/CompanyApi~companySendNotificationToContractSigneeGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * sendNotificationToContractSignee
     * @param {String} _4SAPIAppID 
     * @param {module:api/CompanyApi~companySendNotificationToContractSigneeGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.companySendNotificationToContractSigneeGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling companySendNotificationToContractSigneeGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/Company/sendNotificationToContractSignee', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the companySignPartnerAgreementGet operation.
     * @callback module:api/CompanyApi~companySignPartnerAgreementGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * signPartnerAgreement
     * @param {String} _4SAPIAppID 
     * @param {module:api/CompanyApi~companySignPartnerAgreementGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.companySignPartnerAgreementGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling companySignPartnerAgreementGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/Company/signPartnerAgreement', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
